export default __webpack_public_path__ + "static/media/DSC_7446.20071f72.jpg";